import store from '@/store'
import { Route } from 'vue-router'
import { updateSearchConditions } from './types'
import { Gender, ProgramLevel } from '@/core/Programs'

/**
 * クエリで検索条件が一つでも指定されていればqueryから検索条件をセットする
 * @param query Route['query']
 */
export const setSearchStateByQuery = (query: Route['query']) => {
  const searchParams = [
    'activityIds',
    'areaIds',
    'searchDates',
    'startTimeBefore',
    'startTimeAfter',
    'sexLimitation',
    'level',
    'showFullReservations',
  ]
  const hasSearchQuery: boolean = searchParams.some((param) =>
    Object.keys(query).includes(param)
  )

  if (!hasSearchQuery) {
    return
  }

  store.commit(
    updateSearchConditions({
      activityIds: Array.isArray(query.activityIds)
        ? query.activityIds.map(Number)
        : [],
      areaIds: Array.isArray(query.areaIds) ? query.areaIds.map(Number) : [],
      searchDates: Array.isArray(query.searchDates)
        ? (query.searchDates.filter((d) => d) as string[])
        : [],
      startTimeBefore:
        typeof query.startTimeBefore === 'string' ? query.startTimeBefore : '',
      startTimeAfter:
        typeof query.startTimeAfter === 'string' ? query.startTimeAfter : '',
      sexLimitation: Array.isArray(query.sexLimitation)
        ? (query.sexLimitation as Gender[])
        : [],
      level: Array.isArray(query.level)
        ? ((query.level as string[]).map(Number) as ProgramLevel[])
        : [],
      showFullReservations:
        query.showFullReservations === undefined ||
        query.showFullReservations === 'true' ||
        (query.showFullReservations as any) === true,
    })
  )
}
